import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ArticleService } from './../../core/services/articles/article.service';
import { CreateGyanService } from './../../core/services/create-gyan/create-gyan.service';
import { MessageService } from 'src/app/core/web-socket/message.service';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgScrollbar } from 'ngx-scrollbar';
import * as bootstrap from 'bootstrap';
import { local } from 'd3';

@Component({
    selector: 'app-articles-section',
    templateUrl: './articles-section.component.html',
    styleUrls: ['./articles-section.component.scss'],
})
export class ArticlesSectionComponent implements OnInit {
    articles: any;
    articlesLongStoryData: any;
    loading: boolean = true; //show skeleton
    articleNotAvailable = false;
    isMobile: boolean = false;

    @Input() PreviousGyanId: any;
    @Input() clickBackArticleList: any;
    @Input() clickBackparaids: any;
    @Input() articleExpanded: any;

    @Input() clicbackDataSet: any;

    previousArticleCount: number = 0;
    currentArticleCount: number = 0;

    private previousGyanClicked: Subscription;
    private previousGyanOnload: Subscription;
    private createGyanInitiated: Subscription;
    private callfromSocketArticleList: Subscription;
    private callfromSocketArticleListSummary: Subscription;
    private resetArticleList: Subscription;
    private CallFromSocketForGyanStatus: Subscription;

    sentenceIds = [];
    disabledLoadMoreLink: boolean | undefined;
    subscription: any;

    dt2Count: number = 0;
    toasterMessageShown: boolean = false;
    dataTypeIsGyan: boolean = false; // this variable is to check dataType
    pageScrollNumber: number = 1;
    pageScrollNumberRapid: number = 0;

    userSignIn: boolean = false;
    gyanType: any;
    previousSelectedGyanId: any;
    enableScroll: boolean = true;
    enableRapidScroll: boolean = true;

    @ViewChild('articleListDiv', { static: true }) scrollDiv!: NgScrollbar;
    @Output() subscriptionMessageModal: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private articleService: ArticleService,
        private authService: AuthService,
        private messageService: MessageService,
        private createGyanService: CreateGyanService,
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private toastrService: ToastrService,
    ) {
        this.userSignIn = this.authService.isSignInUser();

        // calling subject to load articles by taking gyan id from localstorage on previousGyanClick
        this.previousGyanClicked = this.commonServiceService.previousGyanClick$.subscribe((value) => {
            if (value.callArticles) {
                const gyanData = this.localStorageService.getItem('gyanData');
                console.log('calling subject to load articles by taking gyan id from localstorage on previousGyanClick');
                this.loading = true;
                console.log('articleNotAvailable 80');
                this.articleNotAvailable = false;
                this.articles = null;
                this.disabledLoadMoreLink = undefined;
                if (gyanData.gyanType === 'rapid') {
                    setTimeout(() => {
                        this.dataTypeIsGyan = false;
                        this.previousArticleCount = 0;
                        this.currentArticleCount = 0;
                        this.dt2Count = 0;
                        this.loadArticleList(0, gyanData.gyanId, 0);
                        //scrolling to top when previous search click
                        // if (this.scrollDiv !== undefined) {
                        //     if (this.scrollDiv?.scrollTo) {
                        //         this.scrollDiv.scrollTo({ top: 0, duration: 100 });
                        //     }
                        // }
                        // Directly use optional chaining to safely call scrollTo
                        this.enableRapidScroll = true; // enabled scroll true for newly clicked gyans
                        this.scrollDiv?.scrollTo({ top: 0, duration: 100 });
                    }, 1000);
                }
                if (gyanData.gyanType === 'gyan') {
                    this.dataTypeIsGyan = true;
                    this.pageScrollNumber = 1;
                    this.loadArticleListAdvanceQuery(1, gyanData.gyanId, gyanData);
                    setTimeout(() => {
                        // if (this.scrollDiv !== undefined) {
                        //     if (this.scrollDiv?.scrollTo) {
                        //         this.scrollDiv.scrollTo({ top: 0, duration: 100 });
                        //     }
                        // }
                        this.scrollDiv?.scrollTo({ top: 0, duration: 100 });
                    }, 1000);
                }
            }
        });

        // calling subject to load articles by taking gyan id from localstorage on previousGyanOnload
        this.previousGyanOnload = this.commonServiceService.previousGyanOnload$.subscribe((value) => {
            if (value) {
                const gyanData = this.localStorageService.getItem('gyanData');
                console.log('calling subject to load articles by taking gyan id from localstorage on previousGyanOnload');
                this.loading = true;
                console.log('articleNotAvailable 122');
                this.articleNotAvailable = false;
                this.articles = null;
                if (gyanData.gyanType === 'rapid') {
                    setTimeout(() => {
                        this.previousArticleCount = 0;
                        this.currentArticleCount = 0;
                        this.loadArticleList(0, gyanData.gyanId, 0);
                    }, 100);
                }
                if (gyanData.gyanType === 'gyan') {
                    this.dataTypeIsGyan = true;
                    this.pageScrollNumber = 1;
                }
            }
        });

        //calling subject when a new Gyan is initiated
        this.createGyanInitiated = this.commonServiceService.createGyanInitiated$.subscribe((value) => {
            if (value) {
                console.log('calling subject when a new Gyan is initiated');
                this.loading = true;
                console.log('articleNotAvailable 144');
                this.articleNotAvailable = false;
                this.disabledLoadMoreLink = undefined;
                const gyanData = this.localStorageService.getItem('gyanData');
                if (gyanData.gyanType === 'rapid') this.dataTypeIsGyan = false;
                else this.dataTypeIsGyan = true;
                setTimeout(() => {
                    this.previousArticleCount = 0;
                    this.currentArticleCount = 0;
                    this.articles = null;
                    // if (this.scrollDiv !== undefined) {
                    //     if (this.scrollDiv?.scrollTo) {
                    //         this.scrollDiv.scrollTo({ top: 0, duration: 100 });
                    //     }
                    // }
                    this.scrollDiv?.scrollTo({ top: 0, duration: 100 });

                    this.toasterMessageShown = false;
                    this.dt2Count = 0;
                    //    this.checkSocketMessage();
                }, 10);
            }
        });

        // calling subject from socket page for Article List
        this.callfromSocketArticleList = this.commonServiceService.callfromSocketArticleList$.subscribe((value) => {
            if (value) {
                console.log('articleNotAvailable 171');
                this.articleNotAvailable = false;
                this.loading = true;
                console.log('calling subject from socket page for Article List');
                const gyanData = this.localStorageService.getItem('gyanData');
                if (gyanData.gyanType === 'rapid') {
                    //    console.log("----------------loadingfromsocket")
                    this.loading = true;
                    this.loadArticleList(1, gyanData.gyanId, 0);
                }
                if (gyanData.gyanType === 'gyan') {
                    //gyanData.articleLength = this.articles?.length;
                    //this.localStorageService.setItem('gyanData', gyanData);
                    if (this.articles?.length === 0) this.loading = true;
                    else this.loading = false;
                    //this.loading = true;
                    this.loadArticleListAdvanceQuery(1, gyanData.gyanId, gyanData);
                }
            }
        });

        // calling subject from socket page for Article List Summary
        this.callfromSocketArticleListSummary = this.commonServiceService.callfromSocketArticleListSummary$.subscribe((value) => {
            if (value) {
                // console.log("----------------loadingfromsocket2")
                this.loading = false;
                console.log('articleNotAvailable 194');
                this.articleNotAvailable = false;
                console.log('calling subject from socket page for Article List Summary');
                const gyanData = this.localStorageService.getItem('gyanData');
                this.dt2Count = this.dt2Count + 1;
                // console.log('dt2Count--------------', this.dt2Count);
                // setTimeout(() => {
                const dt2C = this.dt2Count;
                this.loadArticleList(2, gyanData.gyanId, dt2C);
                // }, 10);
            }
        });

        //calling subject when we reset article list after removing the highlight of MDS
        this.resetArticleList = this.commonServiceService.resetArticleList$.subscribe((value) => {
            if (value) {
                console.log('calling subject when we reset article list after removing the highlight of MDS');
                const gyanData = this.localStorageService.getItem('gyanData');
                this.loading = true;
                //  this.clickBackArticleList = [];
                if (gyanData.gyanType == 'rapid') {
                    setTimeout(() => {
                        this.previousArticleCount = 0;
                        this.currentArticleCount = 0;
                        console.log('articleNotAvailable 219');
                        this.articleNotAvailable = false;
                        this.loadArticleList(0, gyanData.gyanId, 0);
                    }, 100);
                } else if (gyanData.gyanType == 'gyan') {
                    setTimeout(() => {
                        this.loading = true;
                        this.enableScroll = true;
                        this.articles = null;
                        //this.clickBackArticleList=[];
                        this.pageScrollNumber = 1;
                        this.loadArticleListAdvanceQuery(1, gyanData.gyanId, gyanData);
                    }, 100);
                }
            }
        });

        this.CallFromSocketForGyanStatus = this.commonServiceService.CallFromSocketForGyanStatus$.subscribe((value) => {
            if (typeof value !== 'boolean') {
                const gyanDetails = this.localStorageService.getItem('gyanData');
                if (gyanDetails) {
                    console.log('the gyandetail', gyanDetails);
                    console.log('value', value);
                    if (value.data.id === gyanDetails.gyanId) {
                        const gyanData = {
                            gyanName: gyanDetails.gyanName,
                            gyanId: gyanDetails.gyanId,
                            gyanType: gyanDetails.gyanType,
                            gyanCreatedNow: gyanDetails.gyanCreatedNow,
                            gyanStatus: value.data.gyanStatus,
                        };
                        this.localStorageService.setItem('gyanData', gyanData);
                    }
                }
                // if (gyanDetails) {
                //     console.log('the gyandetail', gyanDetails);
                //     if (gyanDetails.gyanId === value.data.id) {
                //         const gyanData = {
                //             gyanName: gyanDetails.gyanName,
                //             gyanId: gyanDetails.gyanId,
                //             gyanType: gyanDetails.gyanType,
                //             gyanCreatedNow: gyanDetails.gyanCreatedNow,
                //             gyanStatus: value.data.gyanStatus,
                //         };
                //         this.localStorageService.setItem('gyanData', gyanData);
                //     }
                // }
                if (value.data?.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                    console.log('loading >> 262');
                    this.loading = true;
                    console.log('articleNotAvailable 239');
                    this.articleNotAvailable = true;
                }
            }
        });
    }

    // eslint-disable-next-line sonarjs/cognitive-complexity
    ngOnChanges(changes: SimpleChanges) {
        //check the gyan type and change the dataTypeIsGyan
        const gyanData = this.localStorageService.getItem('gyanData');
        if (changes['clickBackArticleList']) {
            console.log('ngOnchanges called.--- changes[clickBackArticleList]');
            this.enableScroll = false;
            this.enableRapidScroll = false;
            this.articles = changes['clickBackArticleList']['currentValue'];
        }
        if (changes['clickBackparaids']) this.sentenceIds = changes['clickBackparaids']['currentValue'];
        if (gyanData.gyanType === 'gyan') {
            this.dataTypeIsGyan = true;
            if (!this.articles) this.loadArticleListAdvanceQuery(1, gyanData.gyanId, gyanData);
            if (this.articles) {
                if (this.articles.length > 0) this.loading = false;
                else {
                    console.log('loading >> 287');
                    this.loading = true;
                    if (gyanData?.gyanStatus == 'FINISHED' || gyanData?.gyanStatus == 'FAIL' || gyanData?.gyanStatus == '9' || gyanData?.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                        console.log('articleNotAvailable 278');
                        this.articleNotAvailable = true;
                    }
                }
                this.convertToArticleList(this.articles);
            }
        } else {
            this.dataTypeIsGyan = false;
        }
    }

    ngOnInit() {
        this.checkWidth();
        const gyanData = this.localStorageService.getItem('gyanData');
        this.gyanType = gyanData.gyanType;
        // setTimeout(() => {
        //     this.showSubscriptionMessageModal();
        // }, 100);
    }

    findMoreArticles() {
        if (!this.disabledLoadMoreLink && !this.articleNotAvailable) {
            this.pageScrollNumberRapid = this.pageScrollNumberRapid + 1;
            this.loadArticleListRapidGyan();
        }
        // //console.log(this.articles.length);
        // // if(this.totalArticleCount === this.articles.length){
        // //     this.toastrService.error('You have reached your limit');
        // // }
        // // else
        // // this.loading = true;
        // const gyanData = this.localStorageService.getItem('gyanData');
        // //console.log(gyanData);
        // const reqPayload = {
        //     searchString: gyanData.gyanName,
        //     offset: 20,
        //     personId: this.authService.getPersonId(),
        //     topicId: gyanData.gyanId,
        // };
        // //console.log(reqPayload);
        // this.createGyanService.submitGyan(reqPayload).subscribe({
        //     next: (response: any) => {
        //         if (response.statusCode === 200) {
        //             //this.toastrService.success('Loading More Articles.');
        //             //this.gyanTitleResponseGet.emit(false);
        //             //setting value true after load more articles
        //             //   this.commonServiceService.setFindMoreArticleClick(true);
        //             // if (this.scrollDiv !== undefined) {
        //             //     if (this.scrollDiv?.scrollTo) {
        //             //         this.scrollDiv.scrollTo({ top: 0, duration: 100 });
        //             //     }
        //             // }
        //             //  this.scrollDiv?.scrollTo({ top: 0, duration: 100 });
        //             this.dt2Count = 0;
        //             this.toasterMessageShown = false;
        //         } else {
        //             console.log('Unexpected status code: ', response.statusCode);
        //         }
        //     },
        //     error: (error: HttpErrorResponse) => {
        //         console.log('Error: ', error.message);
        //     },
        //     complete: () => {
        //         //     console.log('Find More Article Called successfully');
        //     },
        // });
    }
    totalArticleCount: number = 0;
    loadArticleListRapidGyan() {
        //debugger;
        const gyanData = this.localStorageService.getItem('gyanData');
        const reqPayload = {
            personId: this.authService.getPersonId(),
            rootNodeId: gyanData.gyanId,
            articleFilter: {
                limit: 20,
                offset: this.pageScrollNumberRapid * 20,
            },
        };

        /* eslint-disable sonarjs/cognitive-complexity */
        this.articleService.getArticleList(reqPayload).subscribe({
            next: (response: HttpResponse<any>) => {
                if (response.status === 200) {
                    //debugger;
                    console.log(response);
                    this.sentenceIds = [];
                    const responseBody = response.body;
                    this.loading = false;
                    if (responseBody.data.articleList.length > 0) {
                        this.articles.push(...responseBody.data.articleList);
                        this.totalArticleCount = this.articles.length;
                        //this.articles = responseBody.data.articleList;
                        //  this.loading = false;
                        // if (this.articles?.length > 0) {
                        //     if (this.totalArticleCount >= 40) {
                        //         this.toastrService.error('You have reached your limit');
                        //     }
                        // }
                        if (this.articles && this.articles.length > 0 && this.totalArticleCount >= 40) {
                            this.toastrService.error('You have reached your limit');
                        }
                    } else {
                        console.log('articleNotAvailable 368');
                        this.articleNotAvailable = true;
                        console.log('dataTYpe 2 - and article count is 0 and dataCount is not reached.');
                        this.disabledLoadMoreLink = true;
                        // this.toastrService.error('Article Not Found. 11');
                        // this.articles = [];
                        //this.loading = true;
                    }
                }
            },
            error: (error: HttpErrorResponse) => {
                /// this is case when 500 error given by dt 1
                console.log('Error: ', error);

                this.toastrService.error('Article Not Found.');
                console.log('articleNotAvailable 383');
                this.articleNotAvailable = true;
                this.disabledLoadMoreLink = true;
                this.loading = true;
            },
            complete: () => {
                console.log(' ------ this.previousArticleCount', this.previousArticleCount);
                console.log(' ------ this.currentArticleCount', this.currentArticleCount);
                console.log(' ------ Article Length ', this.articles?.length);
                //console.log(' ------ dt2Count', dt2Count);
                console.log('Article List get successfully');
                this.commonServiceService.setCallfromSocketArticleList(false);
                this.commonServiceService.setCallfromSocketArticleListSummary(false);
                this.commonServiceService.setResetArticleList(false);
                this.commonServiceService.setCreateGyanInitiated(false);
            },
        });
    }
    moveToAdvanceSearch() {
        const gyanData = this.localStorageService.getItem('gyanData');
        this.disabledLoadMoreLink = true;
        if (this.authService.isSignInUser() && gyanData.gyanType === 'rapid') {
            this.subscriptionMessageModal.emit(true);
            //this.showSubscriptionMessageModal();
        }
    }
    loadArticleList(dataType: any, gyanId: any, dt2Count: any) {
        //debugger;
        this.pageScrollNumberRapid = 0;
        console.log('function called >> loadArticleList');
        console.log('loadArticleList >> dataType');
        console.log(dataType);
        console.log('loadArticleList >> gyanId');
        console.log(gyanId);
        console.log('loadArticleList >> dt2Count');
        console.log(dt2Count);
        //debugger;
        if (dataType == 1) {
            console.log(' this.previousArticleCount', this.previousArticleCount);
            console.log(' this.currentArticleCount', this.currentArticleCount);
            this.previousArticleCount = this.currentArticleCount;
        }

        // console.log('dt2Count--------------', this.dt2Count);
        const reqPayload = {
            personId: this.authService.getPersonId(),
            rootNodeId: gyanId,
            articleFilter: {
                limit: 20,
                offset: 0,
            },
        };
        const gyanData = this.localStorageService.getItem('gyanData');
        console.log('gyanData');
        console.log(gyanData);
        console.log('loadArticleList >> reqPayload');
        console.log(reqPayload);

        /* eslint-disable sonarjs/cognitive-complexity */
        this.articleService.getArticleList(reqPayload).subscribe({
            next: (response: HttpResponse<any>) => {
                console.log('response.body getArticleList', response.body);

                // console.log('response.status', response.status);
                if (response.status === 200) {
                    console.log(response);
                    this.sentenceIds = [];
                    const responseBody = response.body;

                    if (dataType === 0) {
                        this.currentArticleCount = responseBody.data.totalArticleCount;
                        if (responseBody.data.articleList.length > 0) {
                            this.articles = responseBody.data.articleList;
                            this.totalArticleCount = this.articles.length;
                            this.loading = true;
                        } else {
                            this.articles = [];
                            console.log('articleNotAvailable 460');
                            this.articleNotAvailable = true;
                        }
                    } else if (dataType === 1) {
                        //  console.log(' ------ dt2Count', this.dt2Count);
                        this.currentArticleCount = responseBody.data.totalArticleCount;
                        console.log('currentArticleCount -- ', this.currentArticleCount);
                        console.log('previousArticleCount -- ', this.previousArticleCount);
                        if (this.currentArticleCount === this.previousArticleCount) {
                            if (responseBody.data.articleList.length > 0) {
                                this.articles = responseBody.data.articleList;
                                this.totalArticleCount = this.articles.length;
                                this.loading = true;
                            } else {
                                this.toastrService.error('Article Not Found.');
                            }
                            this.disabledLoadMoreLink = true;
                        }
                    } else {
                        if (responseBody.data.articleList.length > 0) {
                            this.currentArticleCount = responseBody.data.totalArticleCount;
                            this.articles = responseBody.data.articleList;
                            this.totalArticleCount = this.articles.length;
                            this.loading = false;
                            if (this.articles?.length >= 40 && dataType === 2) {
                                console.log('this.toasterMessageShown', this.toasterMessageShown);
                                if (!this.toasterMessageShown) {
                                    this.disabledLoadMoreLink = true;
                                    if (this.authService.isSignInUser() && gyanData.gyanType === 'rapid') {
                                        this.subscriptionMessageModal.emit(true);
                                        //this.showSubscriptionMessageModal();
                                    }
                                    // else this.toastrService.error('You have reached your limit.');
                                    // this.toasterMessageShown = true;
                                }
                            }
                        } else {
                            console.log('articleNotAvailable 500');
                            this.articleNotAvailable = true;
                            if (dt2Count == this.currentArticleCount - this.previousArticleCount) {
                                console.log('dataTYpe 2 - and article count is 0 and dataCount is not reached.');
                                this.disabledLoadMoreLink = true;
                                // this.toastrService.error('Article Not Found.');
                                this.articles = [];
                                this.loading = true;
                            } else {
                                console.log('dataTYpe 2 - and article count is 0 and dataCount reached.');
                                //console.log('this.toasterMessageShown', this.toasterMessageShown);
                                //this.loading = true;
                            }
                        }
                    }
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('the error is here -2', error, dataType);
                /// this is case when 500 error given by dt 1
                console.log('Error: ', error);
                if (dataType != 0 && dataType != 2) {
                    this.toastrService.error('Article Not Found.');
                    console.log('articleNotAvailable 522');
                    this.loading = true;
                    this.articleNotAvailable = true;
                    this.disabledLoadMoreLink = true;
                } else {
                    if (dataType == 2 && error.error.statusCode == 422) {
                        console.log('the gyan is deleted');
                    }
                    console.log('articleNotAvailable 527');
                    this.articleNotAvailable = true;
                    this.articles = [];
                    this.loading = true;
                }
            },
            complete: () => {
                console.log(' ------ this.previousArticleCount', this.previousArticleCount);
                console.log(' ------ this.currentArticleCount', this.currentArticleCount);
                console.log(' ------ Article Length ', this.articles?.length);
                //console.log(' ------ dt2Count', dt2Count);
                console.log('Article List get successfully');
                this.commonServiceService.setCallfromSocketArticleList(false);
                this.commonServiceService.setCallfromSocketArticleListSummary(false);
                this.commonServiceService.setResetArticleList(false);
                this.commonServiceService.setCreateGyanInitiated(false);
            },
        });
    }
    convertToArticleList(gyanArticles: []) {
        const articleLists: any = [];
        gyanArticles.forEach((article: any) => {
            const gyanArticle = article;
            const paragraphs: any = [];
            article.contextualSummary.forEach((cs: any) => {
                const para = {
                    sentences: [
                        {
                            sentence: cs.summaryText,
                            sentenceRecordId: cs.paraId,
                        },
                    ],
                };
                paragraphs.push(para);
            });
            gyanArticle.paragraphs = paragraphs;
            gyanArticle.articleId = article.id;
            articleLists.push(gyanArticle);
        });
        return articleLists;
    }

    loadArticleListAdvanceQuery(pageNumber: any, gyanId: any, gyanData: any) {
        const reqPayload = {
            topicId: gyanId,
            pageNumber: pageNumber,
            searchedArticle: true,
            sortBy: [
                {
                    key: 'intentScore',
                    value: 1,
                },
            ],
            filterOn: [
                {
                    key: '',
                },
            ],
        };

        /* eslint-disable sonarjs/cognitive-complexity */
        this.articleService.getArticleListForAdvanceQuery(reqPayload).subscribe({
            next: (response: HttpResponse<any>) => {
                this.dataTypeIsGyan = true;
                if (this.previousSelectedGyanId !== gyanId) {
                    this.articles = null;
                    this.previousSelectedGyanId = gyanId;
                }
                console.log('response.body getArticleListForAdvanceQuery', response.body);
                if (response.status === 200) {
                    console.log(response);
                    // if there is no articles then we are preventing api call on scroll, which using this flag.
                    if (response.body.paragraphs.length === 0) {
                        this.enableScroll = false;
                    } else {
                        this.enableScroll = true;
                    }
                    // const gyanData = this.localStorageService.getItem('gyanData');
                    console.log('getArticleListForAdvanceQuery > gyanData');
                    console.log(gyanData);
                    // if (gyanData.gyanCreatedNow == 'no') {
                    // this case is for loading left panel
                    if (gyanData.gyanStatus == 'FINISHED' || gyanData.gyanStatus == 'FAIL' || gyanData.gyanStatus == '9' || gyanData.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                        this.checkArticleLoadingStatusAndResult(pageNumber, response.body.paragraphs, true);
                    } else {
                        this.checkArticleLoadingStatusAndResult(pageNumber, response.body.paragraphs, false);
                    }
                    // } else if (gyanData.gyanCreatedNow == 'yes') {
                    //gyans that are newly create from submit gyan form
                    // this.checkArticleLoadingStatusAndResult(pageNumber, response.body.paragraphs, true);
                    // }
                    console.log('article', this.articles);
                }
            },
            error: (error: HttpErrorResponse) => {
                /// this is case when 500 error given by dt 1
                console.log('Error: ', error);
                this.toastrService.error('Article Not Found.');
            },
            complete: () => {
                console.log('Article List get successfully');
                this.commonServiceService.setCallfromSocketArticleList(false);
                this.commonServiceService.setCallfromSocketArticleListSummary(false);
                this.commonServiceService.setResetArticleList(false);
                this.commonServiceService.setCreateGyanInitiated(false);
            },
        });
    }

    checkArticleLoadingStatusAndResult(pageNumber: any, paragraphs: any, loadstatus: any) {
        console.log(pageNumber);

        //below code is to add a flag isexpanded to expand and collapse the children(if any)
        paragraphs.forEach((article: any) => {
            console.log('the contextual summary is', article.contextualSummary);
            article.contextualSummary.forEach((cs: any) => {
                this.addIsExpandedFieldInSummary(cs);
            });
        });

        // this.articles = paragraphs;
        // below line is commented for advance query - hierarchy implementation
        // const articles = this.convertToArticleList(paragraphs);
        console.log('checkArticleLoadingStatusAndResult >> articles');

        const articles = paragraphs;

        //  check if an article is already in the list and return the index
        const findArticleIndexById = (articleId: any, list: Array<any>) => list.findIndex((existingArticle) => existingArticle.id === articleId);

        if (pageNumber > 1) {
            articles.forEach((article: { id: any; paragraphs: any; domain: any }) => {
                const index = findArticleIndexById(article.id, this.articles);
                if (index === -1) {
                    this.articles.push(article);
                } else {
                    // Update paragraphs of the existing article
                    this.articles[index].paragraphs = article.paragraphs;
                    this.articles[index].domain = article.domain;
                }
            });
        } else {
            if (this.articles?.length > 1) {
                articles.forEach((article: { id: any; paragraphs: any; domain: any }) => {
                    const index = findArticleIndexById(article.id, this.articles);
                    if (index === -1) {
                        this.articles.push(article);
                    } else {
                        // Update paragraphs of the existing article
                        this.articles[index].paragraphs = article.paragraphs;
                        this.articles[index].domain = article.domain;
                    }
                });
            } else {
                this.articles = articles;
            }
        }

        // //if the list has items stop the loader else keep the placeholder with articles not found message
        if (this.articles.length > 0) this.loading = false;
        else {
            const gyanData = this.localStorageService.getItem('gyanData');
            if (gyanData.callType && gyanData.gyanType == 'gyan') {
                this.loading = true;
                this.articleNotAvailable = true;
            } else {
                this.loading = true;
                // if (loadstatus && this.articles.length === 0) {
                //     console.log('articleNotAvailable 678');
                //     this.articleNotAvailable = true;
                // } else {
                //     console.log('articleNotAvailable 681');
                //     this.articleNotAvailable = false;
                // }
                this.articleNotAvailable = loadstatus;
            }
        }

        console.log('this.articles', this.articles);
    }

    addIsExpandedFieldInSummary(summaryPara: any) {
        console.log('the summaryPara is the', summaryPara);
        if (summaryPara) {
            summaryPara['isExpanded'] = false;
            if (summaryPara.nextLevel) {
                this.addIsExpandedFieldInSummaryChildren(summaryPara.children);
            }
        }
    }
    addIsExpandedFieldInSummaryChildren(children: any) {
        if (children) {
            children.forEach((summary: any) => {
                if (summary) {
                    summary['isExpanded'] = false;
                    if (summary.nextLevel) {
                        this.addIsExpandedFieldInSummary(summary.children);
                    }
                }
            });
        }
    }

    showSubscriptionMessageModal() {
        this.subscriptionMessageModal.emit(true);
    }
    // showSubscriptionMessageModal() {
    //     const modalElement = this.subscriptionMessageModal.nativeElement;
    //     const modalInstance = new bootstrap.Modal(modalElement);
    //     modalInstance.show();
    // }
    // closeSubscriptionMessageModal() {
    //     const modalElement = this.subscriptionMessageModal.nativeElement;
    //     const modalInstance = bootstrap.Modal.getInstance(modalElement);
    //     if (modalInstance) {
    //         modalInstance.hide();
    //     }
    // }

    ngOnDestroy() {
        this.previousGyanClicked.unsubscribe();
        this.previousGyanOnload.unsubscribe();
        this.createGyanInitiated.unsubscribe();
        this.callfromSocketArticleList.unsubscribe();
        this.callfromSocketArticleListSummary.unsubscribe();
        this.resetArticleList.unsubscribe();
        this.CallFromSocketForGyanStatus.unsubscribe();
    }

    checkWidth() {
        const width = window.innerWidth;
        //    console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    onScrollArticleList() {
        // console.log('Article Scrolled');
        this.pageScrollNumber = this.pageScrollNumber + 1;
        const gyanData = this.localStorageService.getItem('gyanData');
        this.loadArticleListAdvanceQuery(this.pageScrollNumber, gyanData.gyanId, gyanData);
    }
}
